/**
 * The endpoints constants module houses endpoints-specific configurations.
 *
 * @module routes.endpoints.constants
 */

angular.module('routes.endpoints.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var endpoints;

      // Set defaults.
      endpoints = {};

      /**
       * Defines endpoints constants.
       *
       * @attribute ENDPOINTS
       * @type String
       * @readOnly
       */
      $provide.constant('ENDPOINTS', endpoints);
    }
  ]);
